import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Kiosk } from './kiosk.component';
import { KioskActions, selectCurrentKioskId } from '../../modules/kiosk';
import { ContentRegistryActions } from '../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  activeKioskId: selectCurrentKioskId,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setKioskMode: KioskActions.setKioskMode,
      fetchKiosk: ContentRegistryActions.fetchKiosk,
      setKioskBySlug: KioskActions.setCurrentKioskBySlug,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Kiosk);
